export default __webpack_public_path__ + "static/media/human.d5129747.jpg";